import { GenericPage } from "../components/common/GenericPage";
import {
  peopleCollapseTableFields,
  peopleTableFields,
} from "../utils/table-fields/peopleTableFields";

export const AllPeople = () => {
  return (
    <GenericPage
      title="All People"
      subtitle="Profiles of notable individuals in the galaxy"
      parentQuery="allPeople"
      childQuery="people"
      tableFields={peopleTableFields}
      collapseFields={peopleCollapseTableFields}
    />
  );
};
